const latestExhibitions = document.querySelectorAll('[data-slider="latest-exhibitions"]');

const latestExhibitionsOptions = {
  slidesPerView: 'auto',
  spaceBetween: 20,
  speed: 800,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'fraction',
  },
};

latestExhibitions.forEach((el) => {
  const parentElem = el.closest('.latest-exhibitions');

  const arrowLeft = parentElem.querySelector('.swiper-button-prev');
  const arrowRight = parentElem.querySelector('.swiper-button-next');
  const pagination = parentElem.querySelector('.swiper-pagination');

  latestExhibitionsOptions.navigation.prevEl = arrowLeft;
  latestExhibitionsOptions.navigation.nextEl = arrowRight;
  latestExhibitionsOptions.pagination.el = pagination;

  new Swiper(el, latestExhibitionsOptions);
});
